// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";



// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyCmeS2KRTbgoyL7x0NMoQ9Vuda5wm6tvLU',
  authDomain: "netflix-react-js-f41dc.firebaseapp.com",
  projectId: "netflix-react-js-f41dc",
  storageBucket: "netflix-react-js-f41dc.appspot.com",
  messagingSenderId: "1081388129979",
  appId: "1:1081388129979:web:389c8a8f1862e5fc88539e"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);